import * as React from "react";
import { IPersonaProps, IPersonaSharedProps, Persona, PersonaCoin } from "office-ui-fabric-react";
import { base64ToUrl } from "../utils/common";
import { useImageUrl } from "../utils/useImageUrl";
import { IWithImage } from "../../entities/common";

export type IImageSource = IWithImage & {
    photo?: string | null;
};

type ImagePersonaProps = Omit<IPersonaProps, "imageUrl" | "text"> & {
    info?: IImageSource | null;
    imageId?: string;
    text: string;
};

type ImagePersonaCoinProps = Omit<IPersonaSharedProps, "imageUrl" | "text"> & {
    info?: IImageSource | null;
    imageId?: string;
    text: string;
};

function useResolvedImageUrl(info?: IImageSource | null, imageId?: string): { imageUrl?: string } {
    const hasInlinePhoto = !!info?.photo;
    const resolvedImageId = hasInlinePhoto ? undefined : (imageId ?? info?.imageId);
    const loadedImageUrl = useImageUrl(resolvedImageId);
    const imageUrl = hasInlinePhoto ? (base64ToUrl(info?.photo) ?? undefined) : (loadedImageUrl ?? undefined);

    return { imageUrl };
}

const ImagePersona = ({ info, imageId, text, ...personaProps }: ImagePersonaProps) => {
    const { imageUrl } = useResolvedImageUrl(info, imageId);

    return <Persona {...personaProps} imageUrl={imageUrl} text={text} />;
};

export const ImagePersonaCoin = ({ info, imageId, text, ...personaCoinProps }: ImagePersonaCoinProps) => {
    const { imageUrl } = useResolvedImageUrl(info, imageId);

    return <PersonaCoin {...personaCoinProps} imageUrl={imageUrl} text={text} />;
};

export const PersonInfoPersonaCoin = ImagePersonaCoin;
export { ImagePersona as PersonInfoPersona };

export default ImagePersona;
